/* eslint-disable react/no-danger */
import { useYoudao } from "@/hooks/useTranslator";
import { immersiveLayzerState } from "@/stores/common";
import { sanitize } from "@/utils/sanitize.util";
import { Chip } from "@material-ui/core";
import { Collapse, Empty } from "antd";
import React, { useMemo } from "react";
import { useSetRecoilState } from "recoil";
import styles from "./styles.module.less";

const { container, clip } = styles;
const { Panel } = Collapse;

interface IProps {
  ePmid: string;
  keywords: string[];
  abstract: { text: string; label: string }[];
  immersiveMode: boolean;
  verbose: boolean;
}

const Abstract: React.FC<IProps> = (props) => {
  const {
    keywords: _keywords,
    abstract: _abstract,
    immersiveMode,
    verbose,
    ePmid,
  } = props;

  const { getTargetYoudao } = useYoudao();

  const abstract = useMemo(() => {
    return getTargetYoudao(ePmid)?.abstract || _abstract;
  }, [_abstract, getTargetYoudao(ePmid)]);

  const keywords = useMemo(() => {
    return getTargetYoudao(ePmid)?.keywords || _keywords;
  }, [_keywords, getTargetYoudao(ePmid)]);

  const defaultActiveItems = [
    keywords.length > 0 ? -1 : undefined,
    ...abstract.map((e, i) => (e.text ? i : undefined)),
  ].filter((e) => typeof e === "number");

  const setHovering = useSetRecoilState(immersiveLayzerState);

  return (
    <div
      className={container}
      onMouseEnter={() => {
        setHovering(true);
      }}
      onMouseLeave={() => {
        setHovering(false);
      }}
    >
      <Collapse defaultActiveKey={defaultActiveItems as number[]}>
        <Panel header={<strong>KEYWORDS</strong>} key={-1}>
          <div className={clip}>
            {keywords?.length > 0 ? (
              keywords.map((e) => (
                <Chip
                  label={
                    <span dangerouslySetInnerHTML={{ __html: sanitize(e) }} />
                  }
                  key={e}
                  variant="outlined"
                />
              ))
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </div>
        </Panel>
        {abstract.map(({ text, label }, i) => (
          <Panel
            header={
              <strong>{label?.toLowerCase() === "none" ? "ALL" : label}</strong>
            }
            // eslint-disable-next-line react/no-array-index-key
            key={i}
          >
            <p
              style={{ marginBottom: "0.5rem" }}
              dangerouslySetInnerHTML={{ __html: sanitize(text) }}
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default Abstract;
